var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-in-app-screen',[_c('div',[_c('test-lazy-scroller'),_c('test-lazy-display-frozenpanetable-xy')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }